<template>
  <div>
    <h5>{{ $t("set_password") }}</h5>

    <validation-observer ref="passwordForm" v-slot="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(onSubmit)" @reset="onReset">
        <b-card>
          <b-row class="m-0 p-0">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <b-form-group
                  id="password-group"
                  :label="$t('password') + ':'"
                  label-for="password"
              >
                <validation-provider
                    name="password"
                    rules="required|min:8"
                    v-slot="{ errors }"
                >
                  <b-input-group>
                    <b-form-input
                        id="password"
                        v-model="form.password"
                        :state="errors.length === 0 ? null : false"
                        :type="showPassword ? 'text' : 'password'"
                        placeholder="Enter password"
                    />
                    <b-input-group-append>
                      <b-button @click="showPassword = !showPassword" class="p-0 pl-2 pr-2" variant="secondary">
                        <b-icon-eye-slash-fill v-if="showPassword" />
                        <b-icon-eye-fill v-else />
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <b-form-group
                  id="repeat-password-group"
                  :label="$t('repeat_password') + ':'"
                  label-for="repeat_password"
              >
                <validation-provider
                    name="repeat password"
                    rules="required|confirmed:password"
                    v-slot="{ errors }"
                >
                  <b-input-group>
                    <b-form-input
                        id="repeat_password"
                        v-model="form.repeat_password"
                        :state="errors.length === 0 ? null : false"
                        :type="showRepeatPassword ? 'text' : 'password'"
                        placeholder="Repeat password"
                    />
                    <b-input-group-append>
                      <b-button @click="showRepeatPassword = !showRepeatPassword" class="p-0 pl-2 pr-2" variant="secondary">
                        <b-icon-eye-slash-fill v-if="showRepeatPassword" />
                        <b-icon-eye-fill v-else />
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </div>
          </b-row>
          <b-row class="m-0 p-0">
            <b-col cols="12" class="text-right">
              <b-button type="submit" variant="primary">
                <feather-icon icon="SaveIcon"></feather-icon>
                {{ $t("save") }}
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import { extend } from 'vee-validate'
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, min, confirmed } from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: (field) => `The ${field} field is required`
})

extend('min', {
  ...min,
  message: (field, params) => `The ${field} field must be at least ${params.length} characters`
})

extend('confirmed', {
  ...confirmed,
  message: (field) => `The ${field} field confirmation does not match`
})

import {
  BButton,
  BCol,
  BForm,
  BRow,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BCard,
  BIconEyeFill,
  BIconEyeSlashFill
} from "bootstrap-vue";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: "SetAdminPassword",

  components: {
    BRow,
    BButton,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BCard,
    BIconEyeFill,
    BIconEyeSlashFill,
    ValidationProvider,
    ValidationObserver
  },

  data() {
    return {
      form: {
        password: '',
        repeat_password: '',
        admin_id: this.$route.params.id
      },
      showPassword: false,
      showRepeatPassword: false
    };
  },

  methods: {
    showSuccessMessage(message) {
      const text = this.$t(message)
      this.$swal({
        position: 'center',
        icon: 'success',
        title: text,
        showConfirmButton: false,
        timer: 1500,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    onSubmit() {
      this.$http.post('/new-admin/set-password', this.form).then((res) => {
        console.log(res);
        if (res.data.status === 200) {
          this.showSuccessMessage(this.$t('password_set_successfully'))
          this.$router.push('/login');
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('error'),
              text: this.$t('invalid_link'),
              icon: 'ErrorIcon',
              variant: 'error',
            },
          })
        }
      });
    },
    onReset() {
      this.form.password = '';
      this.form.repeat_password = '';
    }
  },

  created() {

  }
}
</script>

<style scoped>

</style>